"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M415.7 41.2H82.3c-23 0-41.7 18.6-41.7 41.7v333.4c0 23 18.6 41.7 41.7 41.7h180.4V308.4h-55.4v-64.2h55.4v-47.3c0-54.9 33.5-84.9 82.6-84.9 23.5 0 43.6 1.8 49.5 2.5v57.4h-34c-26.6 0-31.8 12.7-31.8 31.2v41h63.6l-8.3 64.2H329v149.5h86.6c23 0 41.7-18.6 41.7-41.7V82.8c0-23-18.6-41.6-41.6-41.6z"
  });
};

exports.default = _default;